module.exports = __webpack_public_path__ + "aa3814f4c7b5364ae2d767581069f709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-makasete.png
// module id = 2081
// module chunks = 4